import { useQuery } from "@tanstack/react-query";

export function useNotificationMarkDownContentDataMapping(url: string) {
    let { data, isLoading } = useQuery({
        queryKey: [url],
        queryFn: () =>
            fetch(url).then((response) => {
                return response.text();
            }),
    });

    return {
        content: data ?? "",
        isLoading,
    };
}
